<template>
  <content-layout :title="title" :tabs="tabs" :activeTab="activeTab" :spin-show='spinShow'>
    <div class="activity-item mgui-container" slot="/apply/leaving/list">

        <div class="leaving-file" style="max-width: 600px;height:600px;margin:0 auto;padding: 40px 40px 20px;" v-if="!applyData || isEdit">
          <h1 style="text-align: center;margin-bottom:20px">离职证明</h1>
          <div style="text-indent:2em;line-height: 3;margin-bottom:20px">
          本公司员工<Input v-model="leavingForm.username" placeholder="姓名" style="text-align:left;display:inline-block;text-indent:0;width:100px;margin:0 10px"/> ，
          性别<Input v-model="leavingForm.xb" placeholder="性别" style="text-align:left;display:inline-block;text-indent:0;width:60px;margin:0 10px"/> ，
          身份证号码为<Input v-model="leavingForm.sfz" placeholder="身份证" style="text-align:left;display:inline-block;text-indent:0;width:160px;margin:0 10px"/> ，
          因<Input v-model="leavingForm.yy" placeholder="什么原因" style="text-align:left;display:inline-block;text-indent:0;width:100px;margin:0 10px"/>
          提出离职，经双方协商，其本人于<Input v-model="leavingForm.sj" placeholder="时间" style="text-align:left;display:inline-block;text-indent:0;width:100px;margin:0 10px"/>
          离职，特此证明！
            </div>
          <div style="text-align:right">浙江宇脉科技股份有限公司</div>
          <div style="text-align:right;margin-bottom:50px">年 月 日</div>
          <div >
            <Button type="primary" @click="submitApply" :disabled="isDisabled">提交申请</Button>&nbsp; 
            <Button @click="isEdit=false" v-if="isEdit">取消</Button>
          </div>
        </div>
        <div class="leaving-file" style="width: 600px;height:600px;margin:0 auto;padding: 40px 40px 20px;" v-else>
          <h1 style="text-align: center;margin-bottom:20px">离职证明</h1>
          <div style="text-indent:2em;line-height: 3;margin-bottom:20px">
          本公司员工 <strong>{{applyData.content.username||'--'}}</strong>
          性别 <strong>{{applyData.content.xb||'--'}}</strong>
          身份证号码为 <strong>{{applyData.content.sfz||'--'}}</strong>
          因 <strong>{{applyData.content.yy||'--'}}</strong>
          提出离职，经双方协商，其本人于 <strong>{{applyData.content.sj||'--'}}</strong>
          离职，特此证明！
            </div>
          <div style="text-align:right">浙江宇脉科技股份有限公司</div>
          <div style="text-align:right;margin-bottom:50px">{{applyData.content.ssj||'****年**月**日'}}</div>
          <div style="text-align:center;border-top:1px solid #eee;padding-top:30px;display:flex;justify-content:space-between">
            <div v-if="applyData.status==0"><Tag size="large">{{status[applyData.status]}}</Tag></div>
            <div><Button type="primary" @click="handleEdit">修改</Button></div>
            <div v-if="applyData.status==1"><Tag size="large">{{status[applyData.status]}}</Tag></div>
            <div v-if="applyData.status==1"><a :href="'https://api.zjyumai.com/user/leave?id='+applyData.id" target="_black" type="primary">下载文档</a></div>
          </div>
        </div>

    </div>
  </content-layout>
</template>

<script>
  import {formatTime} from '../util/filter'
  import {fetch, put, post} from '../fetch/api'

  // const modelName = 'user'
  export default {
    name: 'Apply',
    components: {
      ContentLayout: resolve => { require(['../components/ContentLayoutComponent'], resolve) }
      // UserEditForm: resolve => { require(['../components/UserEditFormComponent'], resolve) }
    },
    data () {
      return {
        title: '离职证明申请',
        tabs: [
          {'title': '离职证明', 'key': '/apply/leaving/list', 'visible': true},
        ],
        isEdit: false,
        activeTab: '/apply/leaving/list',
        spinShow: true,
        isDisabled: false,
        status: ['审核中', '审核通过', '审核未通过', '已撤销'],
        applyData: {
          id: 0,
          user_id: 0,
          status: 0,
          content: null
        },
        exportTime: [],
        leavingForm: {
          username: '',
          xb: '',
          sfz: '',
          yy: '',
          sj: ''
        },
        page: {
          total: 0,
          page: 1
        }
      }
    },
    watch: {
      $route (to) {
        this.routeChange(to)
      }
    },
    mounted () {
      let action = this.$route.params.action
      if (action) this.leaveCollapse = action + '_' + 0
      this.fetchApplyData()
      this.routeChange(this.$route)
    },
    filters: {
      substr (str) {
        return str.substr(0, 10)
      },
      formatTime (time) {
        if (!time) return '--'
        let date = new Date(time * 1000)
        return formatTime(date, 'yyyy-MM-dd hh:mm')
      }
    },
    methods: {
      handleEdit(){
        this.isEdit = true
        this.leavingForm = this.applyData.content
      },
      submitApply () {
        
            this.isDisabled = true
            let data = {
              id: this.applyData.id,
              user_id: this.applyData.user_id,
              status: this.applyData.status,
              type: '离职申请',
              content: JSON.stringify(this.leavingForm)
            }
            post('console/apply', data).then(res => {
              this.fetchApplyData()
              this.isEdit = false
              this.$Message.info(res.msg)
            })
            setTimeout(() => {
              this.isDisabled = false
            }, 2000)
      },
      fetchApplyData () {
        fetch(`users/leave`).then(res => {
          const resData = res.result
          if (resData) resData.content = JSON.parse(resData.content)
          this.applyData = resData
          this.spinShow = false
        }).catch(() => {
          this.spinShow = false
        })
      },
      routeChange (route) {
        let action = route.params.action
        if (action === undefined) {
          this.activeTab = '/apply/leaving/list'
          // this.fetchData()
          this.spinShow = false
        }
        if (action === 'form') {
          this.activeTab = '/apply/leaving/form'
          this.spinShow = false
        }
      },
      read (item) {
        if (item.status === 0) {
          item.status = 1
          put(`console/applyStatus/${item.id}?status=${item.status}`).then(res => {
            console.log(res)
          })
        }
      }
    }
  }
</script>

<style>
  
</style>
